.bulk-create-contacts-from-attendees-popover {
    max-height: 600px;
    overflow-y: auto;
    /* Left + top padding prevents some checkbox elements from being cut off */
    padding: 4px 0 24px 4px;
}
